import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const ScrollArea = styled(Box)(({ theme }) => ({
  overflow: 'auto',
  scrollbarGutter: 'stable',
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: theme.palette.background.paper,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.primary.main,
    borderRadius: '4px',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.primary.main} ${theme.palette.background.paper}`,
}));

export const useStyles = makeStyles((theme) => ({
  content: {
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    color: '#1C2541',
    flex: 1,
    position: 'relative',
    backgroundColor: '#ffffff',
  },
  uploadContainer: {
    borderStyle: 'dashed',
    borderWidth: theme.spacing(0.25),
    borderColor: '#fae8ff',
    borderRadius: theme.spacing(1),
    cursor: 'pointer',
    padding: theme.spacing(2),
    height: theme.spacing(37.5),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  stickyContainer: {
    position: 'sticky',
    top: 0,
    backgroundColor: '#ffffff',
    zIndex: 99999,
  },
  uploadContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  title: {
    fontSize: theme.spacing(2.5),
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  uploadContentSubtitle: {
    fontSize: '14px',
    color: '#71717a',
  },
  uploadContentIcon: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: theme.spacing(7),
    height: theme.spacing(7),
    borderRadius: '50%',
    backgroundColor: '#fae8ff',
  },
  uploadIcon: {
    fontSize: theme.spacing(3.75),
    color: '#3f3f46',
  },
  clickHereLink: {
    color: '#c026d3',
    cursor: 'pointer',
  },
  hidden: {
    display: 'none',
  },
  fileUploadPreviewContainer: {
    marginTop: theme.spacing(1),
  },
  fileUploadPreview: {
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  uploadButton: {
    marginTop: theme.spacing(2),
    color: '#ffffff',
    fontSize: theme.spacing(2),
    width: '97%',
    marginBottom: theme.spacing(2),
  },
  mutedBackground: {
    backgroundColor: '#f5f5f5',
  },
  reducedHeight: {
    height: theme.spacing(25),
  },
  uploadPreviewText: {
    fontSize: theme.spacing(2),
    color: '#71717a',
    marginTop: theme.spacing(3),
  },
  uploadSpinner: {
    marginLeft: theme.spacing(1),
  },
  tagsInputs: {
    display: 'flex',
    width: '100%',
    gap: theme.spacing(1),
  },
  tagInputField: {
    display: 'flex',
    flex: 1,
    width: '100%',
    maxWidth: '100%',
  },
  bulkAssignContainer: {
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  bulkAssignTitle: {
    fontSize: theme.spacing(2),
    fontWeight: 'semibold',
  },
}));
